import systemNotificationsTypes from './systemNotificationsTypes';
import systemNotificationsApi from './systemNotificationsApi';

const systemNotificationsActions = {
    getActiveCampaigns: (branchId) => async (dispatch) => {
        dispatch({ type: systemNotificationsTypes.GET_ACTIVE_CAMPAIGNS_PENDING });
        try {
            const res = await systemNotificationsApi.getActiveCampaigns(branchId);
            const campaigns = res.data || [];
            dispatch({
                type: systemNotificationsTypes.GET_ACTIVE_CAMPAIGNS_SUCCESS,
                payload: campaigns,
            });
            if (campaigns.length > 0) {
                const notifRes = await systemNotificationsApi.getNotification(campaigns[0].notification_id);
                dispatch({
                    type: systemNotificationsTypes.SET_NOTIFICATION_CONTENT,
                    payload: notifRes.data,
                });
            }
        } catch (e) {
            dispatch({ type: systemNotificationsTypes.GET_ACTIVE_CAMPAIGNS_ERROR });
        }
    },

    respondToCampaign: (branchId, campaignId, body) => async (dispatch, getState) => {
        dispatch({ type: systemNotificationsTypes.RESPOND_PENDING });
        try {
            await systemNotificationsApi.respond(branchId, campaignId, body);
            dispatch({ type: systemNotificationsTypes.RESPOND_SUCCESS });
            // After RESPOND_SUCCESS the reducer removes campaigns[0], so getState() reflects the updated list
            const { campaigns } = getState().systemNotificationsReducer;
            if (campaigns.length > 0) {
                const notifRes = await systemNotificationsApi.getNotification(campaigns[0].notification_id);
                dispatch({
                    type: systemNotificationsTypes.SET_NOTIFICATION_CONTENT,
                    payload: notifRes.data,
                });
            }
        } catch (e) {
            dispatch({ type: systemNotificationsTypes.RESPOND_ERROR });
        }
    },
};

export default systemNotificationsActions;
